/* eslint-disable jsx-a11y/anchor-has-content,react/no-danger */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import Paragraph from "../Paragraph";
import {filterUrl, isInternalLink} from "../../helpers/filters";
import IconArrowSVG from '../../../public/images/global/icon__arrow.svg';
import "./_yitm__general.scss";

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        type {
          targetId
        }
        ... on ParagraphMobileComponentSection {
          fieldTxtHeadline
          fieldSectionItems {
            ... on FieldParagraphFieldSectionItems {
              targetRevisionId
            }
          }
          fieldLink {
            ... on FieldParagraphFieldLink {
              url {
                path
                routed
              }
              title
            }
          }
          fieldSectionColor
          fieldCssId
        }
      }
    }
  }
}
`;

class MobileComponentSection extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        componentIndex: PropTypes.number,
        markComponentLoadedAs: PropTypes.func.isRequired,
        handleLoadedComponents: PropTypes.func.isRequired
    };

    static defaultProps = {
        componentIndex: null
    };

    getHeadline(headline) {
        const {componentIndex} = this.props;
        if (!headline) return null;

        // Set H1 or H2 according to component order
        const isFirstComponent = componentIndex === 0;

        if (isFirstComponent) return (<h1 className="mobileComponentSection__title">{headline}</h1>);

        return (<h2 className="mobileComponentSection__title">{headline}</h2>);
    }

    render() {
        const {id, componentIndex, markComponentLoadedAs, handleLoadedComponents} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;
                    const headline = this.getHeadline(field.fieldTxtHeadline);
                    const components = field.fieldSectionItems.length ? field.fieldSectionItems : [];

                    markComponentLoadedAs(id, true);

                    return (
                        <section id={field.fieldCssId} className={`yitm__section yitm__section--${id}`}>

                            {field.fieldSectionColor ? (
                                <style dangerouslySetInnerHTML={{__html: `
                                  .yitm__section--${id} .yitm__sectionHeader {
                                    background-color: ${field.fieldSectionColor};
                                    color: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__listCta {
                                    background-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__listCta > a {
                                    color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__listCta > a > svg > path {
                                    fill: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__listCta > a::after {
                                    background-color: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__sectionHeader h1,
                                  .yitm__section--${id} .yitm__sectionHeader h2 {
                                    color: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__splitArticleImageIcon {
                                    background-color: ${field.fieldSectionColor};
                                    border-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__contentSlideIcon {
                                    background-color: ${field.fieldSectionColor};
                                    border-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__contentSlideTarget:hover ~ .yitm__contentSlideIcon,
                                  .yitm__section--${id} .yitm__contentSlideTarget:focus ~ .yitm__contentSlideIcon {
                                    color: ${field.fieldSectionColor} !important;
                                  }
                                  .yitm__section--${id} .yitm__contentSlideCat {
                                    color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__contentSlideMain {
                                    border-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__contentSlideTarget:hover ~ .yitm__contentSlideMain,
                                  .yitm__section--${id} .yitm__contentSlideTarget:focus ~ .yitm__contentSlideMain {
                                    background-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__callout a {
                                    color: ${field.fieldSectionColor} !important;
                                    border-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__callout a:hover {
                                    background-color: ${field.fieldSectionColor};
                                    border-color: ${field.fieldSectionColor};
                                    color: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__callout a > svg > path {
                                    fill: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__videoDetails--slide span + span {
                                    color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__videoDetails--slide span + span > svg > path {
                                    fill: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} .yitm__list li,
                                  .yitm__section--${id} .yitm__list li strong {
                                      color: #fff !important;
                                  }
                                  .yitm__section--${id} .yitm__list + .yitm__listCta a {
                                      border-color: ${field.fieldSectionColor};
                                  }
                                  .yitm__section--${id} a {
                                    color: ${field.fieldSectionColor} !important;
                                  }
                                  .yitm__section--${id} a > svg > path {
                                    fill: ${field.fieldSectionColor};
                                  }
                                  `}} />
                            ) : null}

                            {headline ? (
                                <header className="yitm__sectionHeader">
                                    <div className="container">
                                        {headline}
                                    </div>
                                </header>
                            ) : null}

                            {components.map((component, index) => <Paragraph key={`${id}_${component.targetRevisionId}`}
                                                                             componentIndex={componentIndex}
                                                                             index={index}
                                                                             id={String(component.targetRevisionId)}
                                                                             handleLoadedComponents={handleLoadedComponents}/>)}

                            {field.fieldLink && field.fieldLink.url && field.fieldLink.url.path ? (
                                <div className="yitm__listCta container" style={{paddingTop: '6px', paddingBottom: '18px'}}>
                                    <a target={isInternalLink(field.fieldLink.url.path) ? '_self' : '_blank'}
                                       rel={isInternalLink(field.fieldLink.url.path) ? null : 'noopener noreferrer'}
                                       href={filterUrl(field.fieldLink.url.path)}>
                                        {field.fieldLink.title} <IconArrowSVG/>
                                    </a>
                                </div>
                            ) : null}

                        </section>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentSection;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentSection.jsx